import StringUtil from "utils/StringUtil";

import IValidationRule from "./ValidationRule";

export default class ValidationRuleCellPhone implements IValidationRule {
  private _message: string | undefined;

  public get message(): string | undefined {
    return this._message;
  }

  public check(value: any): boolean {
    this._message = undefined;

    if (StringUtil.isEmpty(value)) {
      this._message = `휴대폰번호를 입력해주세요.`;
      return false;
    }

    const firstNumber = value.substr(0, 3);
    const regExp =
      firstNumber === "011" || firstNumber === "016" || firstNumber === "017" || firstNumber === "018" || firstNumber === "019"
        ? /^01(?:0|1|[6-9])\d{3}\d{4}$/
        : /^01(?:0|1|[6-9])\d{4}\d{4}$/;

    if (regExp.test(value) !== true) {
      this._message = `휴대폰번호가 올바르지 않습니다. 하이픈(-)을 제외한 숫자만 입력하세요.`;

      return false;
    }

    return true;
  }
}
